import _extends from "@babel/runtime/helpers/esm/extends";
import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

import styled, { css } from 'styled-components';
var variantStyles = {
  "default": css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref) {
    var theme = _ref.theme;
    return _extends({}, theme.button["default"]);
  }),
  error: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref2) {
    var theme = _ref2.theme;
    return _extends({}, theme.button.error);
  }),
  outlined: css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref3) {
    var theme = _ref3.theme;
    return _extends({}, theme.button.outlined);
  }),
  primary: css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref4) {
    var theme = _ref4.theme;
    return _extends({}, theme.button.primary);
  }),
  success: css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", "\n  "])), function (_ref5) {
    var theme = _ref5.theme;
    return _extends({}, theme.button.success);
  })
};
export var Button = styled.button(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  border: 1px solid;\n  outline: none;\n  user-select: none;\n  text-align: center;\n  font-style: normal;\n  font-stretch: normal;\n  letter-spacing: normal;\n  -webkit-font-smoothing: antialiased;\n  backface-visibility: hidden;\n  cursor: pointer;\n  font-size: ", ";\n  height: ", ";\n  padding: ", ";\n\n  ", ";\n  ", ";\n\n  &:hover:not([disabled]) {\n    box-shadow: none;\n  }\n\n  &:disabled {\n    cursor: not-allowed;\n    box-shadow: none;\n    ", "\n  }\n\n  /* transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1), box-shadow 400ms cubic-bezier(0.25, 0.8, 0.25, 1);\n  transform: perspective(100px) translateZ(0);\n  will-change: transform, box-shadow; */\n"])), function (_ref6) {
  var size = _ref6.size,
      theme = _ref6.theme;
  return theme.button.fontSize[size];
}, function (_ref7) {
  var size = _ref7.size,
      theme = _ref7.theme;
  return theme.button.height[size];
}, function (_ref8) {
  var size = _ref8.size,
      theme = _ref8.theme;
  return theme.button.padding[size];
}, function (_ref9) {
  var variant = _ref9.variant;
  return variantStyles[variant];
}, function (_ref10) {
  var isLoading = _ref10.isLoading;
  return isLoading && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([" box-shadow: none; "])));
}, function (_ref11) {
  var variant = _ref11.variant,
      theme = _ref11.theme;
  return _extends({}, theme.button.disabled[variant]);
});